import { GetServerSideProps } from 'next';
import PricingContainer from '@app/containers/PricingContainer';

export const getServerSideProps: GetServerSideProps = async (context) => {
  console.log('getServerSideProps is being called for /pricing');

  const { res } = context;
  res.setHeader(
    'Cache-Control',
    'no-store, no-cache, must-revalidate, proxy-revalidate',
  );
  res.setHeader('Pragma', 'no-cache');
  res.setHeader('Expires', '0');

  // Example server-side data to verify it's working
  const exampleData = { message: 'Pricing data fetched server-side' };

  return {
    props: {
      exampleData,
    },
  };
};

export default PricingContainer;
